<template>
    <section class="mentor-profile-editor">
        <div class="working" v-show="working">
            <div class="sk-folding-cube">
                <div class="sk-cube1 sk-cube"></div>
                <div class="sk-cube2 sk-cube"></div>
                <div class="sk-cube4 sk-cube"></div>
                <div class="sk-cube3 sk-cube"></div>
            </div>
        </div>
        <div class="panel" v-if="profile">
            <div class="panel-heading">
                <h2>Mentor Selector Profile</h2>
            </div>
            <div class="panel-body">
                <form @submit.prevent="updateProfile()">
                    <h4 class="bump">General Information</h4>
                    I work for <input v-model.trim="profile.company" required>
                    company's URL <input v-model.trim="profile.companyUrl" required placeholder="http://etc"><br>
                    And my current position/title is <input v-model.trim="profile.position" required><br>
                    Living in <input v-model.trim="profile.location" required>
                    the industry I work in is
                    <select v-model="profile.industry" required>
                        <option value="" default selected>choose</option>
                        <option value="vfx">VFX / Film & TV</option>
                        <option value="video_games">Video Game & VR / AR</option>
                        <option value="both">Both VFX and Games</option>
                    </select>
                    <br><br>
                    I am currently
                    <select v-model="profile.status" required>
                        <option value="" default selected>choose</option>
                        <option value="unconfirmed">Unconfirmed</option>
                        <option value="available">Available</option>
                        <option value="unavailable">Unavailable</option>
                        <option value="archive/hidden">Archive/Hidden</option>
                    </select>
                    to mentor
                    <select v-model="profile.seats" required>
                        <option value="" default selected>choose</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                    </select>
                    student(s)
                    <br><br>
                    I'd like to connect with my mentees on the
                    <select v-model="profile.availableDays" required>
                        <option value="" default selected>choose</option>
                        <option value="weekdays">week days</option>
                        <option value="weekends">weekends</option>
                        <option value="both">any time of the week</option>
                    </select>
                    during
                    <select v-model="profile.availableTimes" required>
                        <option value="" default selected>choose</option>
                        <option value="mornings">mornings</option>
                        <option value="afternoons">afternoons</option>
                        <option value="evenings">evenings</option>
                        <option value="any">anytime of the day</option>
                    </select>
                    <br><br>
                    <h4>My Specialties Include</h4>
                    <ul class="specialties">
                        <li v-for="specialty in specialties">
                            <input 
                                :checked="profile.specialties.indexOf(specialty) > -1" 
                                type="checkbox" 
                                :id="specialty" 
                                :value="specialty" 
                                @change="setSpecialties(specialty)">
                            <label :for="specialty">
                                {{specialty | deslugify}}
                            </label>
                        </li>
                    </ul>
                    <div v-if="profile.nextTermVenue !== 'campus'">
                        <h4>Student Learning Path(s) Applicable to your Experience:</h4>
                        <ul class="specialties">
                            <li v-for="path in paths">
                                <input 
                                    :checked="profile.paths.find(p => p.id === path.id)" 
                                    type="checkbox" 
                                    :id="'path_' + path.id" 
                                    :value="path.name" 
                                    @change="setPaths(path)">
                                <label :for="'path_' + path.id">
                                    {{path.name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                    <h4>Short Bio</h4>
                    <textarea v-model="profile.bio" required></textarea>
                    <br>
                    Featured Artwork <label class="file" for="featuredImage">Upload</label>
                    <input @change="upload('featuredImage', $event.target.files[0])" class="file" type="file" id="featuredImage">
                    <img v-if="profile.featuredImage" :src="profile.featuredImage" class="avatar">
                    <br><br>
                    <label>Demo Reel URL (optional)</label>
                    <input class="demoreel" v-model="profile.demoReelUrl" placeholder="http://etc">
                    <br>
                    <h4>Image / Work Gallery</h4>
                    <ul class="gallery">
                        <li v-for="(image, $index) in profile.gallery" class="deletable">
                            <i @click="deleteItem('gallery',image, $index)" class="fa fa-remove delete"></i>
                            <img :src="image">
                        </li>
                    </ul>
                    <dropzone id="gallery" ref="gallery" url="#" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="0" v-bind:dropzone-options="dropzoneOptions">
                    </dropzone>
                    <h4>Credits (Box Art / Posters)</h4>
                    <ul class="gallery">
                        <li v-for="(image,$index) in profile.credits" class="deletable">
                            <i @click="deleteItem('credits',image, $index)" class="fa fa-remove delete"></i>
                            <img :src="image">
                        </li>
                    </ul>
                    <dropzone id="credits" ref="credits" url="#" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="0" v-bind:dropzone-options="dropzoneOptions">
                    </dropzone>
                    <div class="social">
                        <h4>Social Sites</h4>
                        <ul class="social-sites">
                            <li v-for="(site, $index) in profile.socialSites" class="deletable">
                                <i @click="deleteItem('socialSites', site, $index)" class="fa fa-remove delete"></i>
                                <a :href="addProtocol(site.url)" target="_blank">{{site.site}}</a>
                            </li>
                        </ul>
                        <select v-model="socialSite.site">
                            <option v-for="site in socialSites" :value="site">{{site}}</option>
                        </select>
                        <input v-model.trim="socialSite.url" placeholder="http://etc">
                        <button @click.prevent="addSocialSite()">Add</button>
                    </div>
                    <br>
                    <div class="students">
                        <h4>Past Mentored Students</h4>
                        <input v-model.trim="student.name" placeholder="Name">
                        <input class="student-links" v-model.trim="student.urls" placeholder="Links (separated by commas)">
                        <label class="file" for="studentAvatar">
                            Avatar
                        </label>
                        <img v-if="student.avatar" :src="student.avatar" class="student-avatar">
                        <input @change="upload('studentAvatar', $event.target.files[0])" type="file" class="file" ref="studentAvatar" id="studentAvatar">
                        <h5>Student's Sample Image(s)</h5>
                        <dropzone id="studentImages" ref="studentImages" url="#" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="0" v-bind:dropzone-options="dropzoneOptions">
                        </dropzone>
                        <div class="button-wrapper">
                            <button @click.prevent="addStudent()">Add Student</button>
                            <span class="warning">When adding previous students, please commit each one before updating your profile by clicking the ‘Add Student’ button first.</span>
                        </div>
                    </div>
                    <ul class="mentored-students">
                        <li v-for="(student, $index) in profile.pastMentoredStudents" class="deletable">
                            <i @click="deleteItem('pastMentoredStudents', student, $index)" class="fa fa-remove delete"></i>
                            <img class="student-avatar" :src="student.avatar">
                            <br>
                            {{student.name}}
                        </li>
                    </ul>
                    <router-link class="profile-link" target="_blank" :to="{name: 'mentorProfile', params:{id: localStorage.user_id}}">
                        View Profile
                    </router-link>
                    <button type="submit">Create / Update Profile</button>
                </form>
            </div>
        </div>
    </section>
</template>
<script>
import aws from '../services/aws';
import mentors from '../services/mentors';

import Dropzone from 'vue2-dropzone';
import toastr from 'toastr';
const uuidV4 = require('uuid/v4');

export default {
    data() {
        return {
            profile: null,
            socialSite: {
                site: 'IMDB',
                url: null
            },
            student: {
                name: null,
                avatar: null,
                urls: null,
                images: []
            },
            socialSites: ['Artstation', 'IMDB', 'MobyGames', 'Instagram', 'GroupPhoto', 'LinkedIn', 'Facebook', 'Twitter', 'Personal Website'],
            specialties: ["character_modeling", "props_modeling", "lighting", "texturing", "vehicles", "generalist", "creatures", "environments", "look_dev", "character_animation", "art_direction", "compositing", "technical_director", "concept_art", "matte_painting"],
            dropzoneOptions: {
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
                dictDefaultMessage: '(drag images here)'
            },
            working: false,
            paths: [
                { name: 'Characters & Creatures for Film', id: 9130 },
                { name: 'Environments & Props for Film', id: 9131 },
                { name: 'Characters & Creatures for Games', id: 6643 },
                { name: 'Environments & Props for Games', id: 6627 },
                { name: 'Not applicable', id: 9999 },
            ]
        }
    },
    components: { Dropzone },
    mounted() {
        this.getProfile();
        this.getMentees();
    },
    methods: {
        getMentees() {
            mentors.getMentees().then((response)=>{
                console.log(response)
            })
        },
        addProtocol(url) {
            if (!url.includes('http')) {
                url = 'https://' + url;
            }
            return url;
        },
        deleteItem(type, item, index) {
            var self = this;
            self.working = true;
            mentors.deleteItem(this, type, item).then(function(response) {
                self.working = false;
                if (response.data.success === true) {
                    self.profile[type].splice(index, 1);
                } else {
                    toastr.error('Error deleting item');
                }
            });
        },
        getProfile() {
            var self = this;
            mentors.getProfile(this, localStorage.user_id).then(function(response) {
                if (!response.data.profile.paths) {
                    response.data.profile.paths = [];
                }
                self.profile = response.data.profile;
            });
        },
        updateProfile() {
            var self = this;

            let promises = [];

            if (!self.profile.featuredImage || self.profile.featuredImage == '') {
                toastr.error('Please add featured artwork');
                return;
            }

            if (self.profile.nextTermVenue !== 'campus' 
                    && (!self.profile.paths || self.profile.paths.length === 0)) {
                toastr.error('Please select at least one learning path');
                return;
            }


            if (self.profile.demoReelUrl) {
                if (!self.profile.demoReelUrl.includes('youtube') && !self.profile.demoReelUrl.includes('vimeo')) {
                    toastr.error('Only YouTube and Vimeo links are supported for your demo reel');
                    return;
                }
            }

            if (this.$refs.gallery.dropzone.files) {
                this.$refs.gallery.dropzone.files.forEach(function(file) {
                    let promise = new Promise(function(resolve, reject) {
                        self.upload('gallery', file).then(function(url) {
                            self.profile.gallery.push(url);
                            resolve();
                        });
                    });
                    promises.push(promise);
                });
            }

            if (this.$refs.credits.dropzone.files) {
                this.$refs.credits.dropzone.files.forEach(function(file) {
                    let promise = new Promise(function(resolve, reject) {
                        self.upload('credits', file).then(function(url) {
                            self.profile.credits.push(url);
                            resolve();
                        });
                    });
                    promises.push(promise);
                });
            }

            Promise.all(promises).then(function() {
                self.$refs.gallery.dropzone.removeAllFiles();
                self.$refs.credits.dropzone.removeAllFiles();
                self.working = true;
                mentors.updateProfile(self, self.profile).then(function(response) {
                    self.working = false;
                    response.data.success === true ? toastr.success('Success!') : toastr.error('Error updating profile');
                });
            }).catch(function(e) {
                console.log(e);
            })


        },
        addStudent() {
            var self = this;

            if (!self.student.name || !self.student.urls) {
                toastr.error('Please add a name and URLs');
                return;
            }
            if (!this.student.avatar) {
                toastr.error('Please add an avatar');
                return;
            }
            if (!this.$refs.studentImages.dropzone.files || this.$refs.studentImages.dropzone.files.length === 0) {
                toastr.error('Please add at least one image');
                return;
            }


            let promises = [];

            self.$refs.studentImages.dropzone.files.forEach(function(file) {
                let promise = new Promise(function(resolve, reject) {
                    self.upload('studentImage', file).then(function(imageUrl) {
                        self.student.images.push(imageUrl);
                        resolve();
                    });
                });
                promises.push(promise);
            });

            Promise.all(promises).then(function() {
                self.profile.pastMentoredStudents.push(self.student);
                self.student = {
                    name: null,
                    avatar: null,
                    urls: null,
                    images: []
                }
                self.$refs.studentImages.dropzone.removeAllFiles();

            });
        },
        upload(type, file) {
            var self = this;
            self.working = true;
            let bucket = '';

            const filename = uuidV4() + '.' + file.name.split('.').pop();

            switch (type) {
                case 'avatar':
                    bucket = 'ttto-mentor-avatars';
                    break;
                case 'credits':
                    bucket = 'ttto-mentor-credits';
                    break;
                case 'gallery':
                    bucket = 'ttto-mentor-gallery';
                    break;
                case 'studentAvatar':
                    bucket = 'ttto-mentor-student-avatars';
                    break;
                case 'studentImage':
                    bucket = 'ttto-mentor-student-images';
                    break;
                case 'featuredImage':
                    bucket = 'ttto-mentor-featured-images';
                    break;
            }

            return new Promise(function(resolve, reject) {
                aws.signature(file, filename, bucket).then(function(signature) {
                    aws.getPresignedUrl(self, bucket, filename, 'putObject').then(function(presignedUrl) {
                        aws.upload(file, filename, signature, bucket, presignedUrl.data).then(function(response) {
                            if (self.profile.hasOwnProperty(type) && !Array.isArray(self.profile[type])) {
                                self.profile[type] = response.url;
                            }
                            if (type === 'studentAvatar') {
                                self.student.avatar = response.url;
                            }
                            resolve(response.url);
                            self.working = false;
                        }).catch(function(error) {
                            self.working = false;
                            console.log(error);
                            resolve(false)
                        });
                    });
                });
            });
        },
        setPaths(path) {
            let index = this.profile.paths.findIndex(p => p.id === path.id);
            index === -1 ? this.profile.paths.push(path) : this.profile.paths.splice(index, 1)
        },
        setSpecialties(specialty) {
            let index = this.profile.specialties.indexOf(specialty);
            index === -1 ? this.profile.specialties.push(specialty) : this.profile.specialties.splice(index, 1)
        },
        addSocialSite(site) {
            this.profile.socialSites.push(this.socialSite);
            this.socialSite = {
                site: 'IMDB',
                url: null
            }
        }
    }
}

</script>
<style lang="scss" scoped>
h4 {
    color: #b0b0b0;
    font-weight: 300;
    font-size: 1.5em;
}

h4.bump {
    margin-bottom: 25px;
}

form {
    padding: 2rem;
    font-size: 1.6rem;
    line-height: 3rem;

    input,
    textarea,
    button {
        background: #1a1a1a;
        color: #ededed;
        padding: 10px;
        margin: 0 1rem;
        border: 1px solid #555;
        line-height: initial;
        margin: 1rem;
    }

    textarea {
        height: 200px;
        width: 800px;
        margin-top: 1rem;
        font-weight: 100;
        font-size: .9em;
    }

    option {
        background: #000;
    }

    select {
        background: transparent;
        border: none;
        margin: 0 1rem;
        display: inline-block;
        border-bottom: 1px solid #555;
    }

    br {
        line-height: 6rem;
    }

    .specialties {
        padding: 1rem 3rem;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;

        li {
            margin: 1rem;
            background: #1a1a1a;
            padding: 0;
            border: 1px solid #555;

        }

        label {
            padding: 5px 10px;
            margin: 0;
            margin-top: -3px;
            cursor: pointer;
            font-weight: 300 !important;
        }

        input[type="checkbox"] {
            display: none;
        }

        input[type="checkbox"]:checked+label {
            background: #ccc;
            color: #1a1a1a;
            font-weight: 700 !important;
        }
    }

    button[type="submit"],
    .profile-link {
        background: #3cf;
        color: #1a1a1a;
        float: right;
        padding: 1rem;
        margin-bottom: 4rem;
    }

    button[type="submit"] {
        height: 5rem;
        top: -10px;
        position: relative;
    }

    .demoreel {
        width: 400px;
    }
}

input.file {
    display: none;
}

label.file {
    background: #3cf;
    color: #000;
    font-weight: 600 !important;
    padding: 1rem 25px;
    margin: 0 1rem 0 1rem;
    border: 1px solid #555;
    cursor: pointer;
}

.students {
    margin-bottom: 4rem;

    .file {
        position: relative;
        top: 0;
    }

    .button-wrapper {
        margin-top: -3rem;
    }

    .warning {
        width: 370px;
        display: inline-block;
        position: relative;
        top: 2rem;
        line-height: 1.2em;
    }

    h5 {
        margin-top: 2rem;
        padding-left: 1rem;
    }

    #studentImages {
        margin-left: 1rem;
    }
}

.student-links {
    width: 400px;
}

.student-avatar {
    width: 120px;
    height: auto;
}

.social,
.students {
    select {
        border: 1px solid #555;
        text-align: center;
        height: 44px;
        margin-top: 2rem;
    }

    button {
        padding: 5px 25px;
    }
}

ul.mentored-students {
    margin-top: 2rem;

    li {
        max-width: 120px;
    }
}

.dropzone {
    margin-top: 1rem;
    max-width: 400px;
    border: 1px solid #555;
}

.avatar,
.featured-image {
    max-width: 120px;
}

.social {
    h4 {
        margin-bottom: 3rem;
    }
}

.social-sites {
    ul {
        margin-top: 5rem;
    }

    li {
        margin: 1rem 0;
        max-width: 180px;
    }
}

.gallery {
    display: flex;
    flex-wrap: wrap;
    margin: 2rem 0;

    li {
        max-width: 200px;
        margin: 1rem;

        img {
            width: 100%;
        }
    }
}

.deletable {
    position: relative;

    .delete {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
    }
}

.working {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(25, 25, 25, .6);
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sk-folding-cube {
    margin: 20px auto;
    width: 80px;
    height: 80px;
    position: relative;
    -webkit-transform: rotateZ(45deg);
    transform: rotateZ(45deg);
}

.sk-folding-cube .sk-cube {
    float: left;
    width: 50%;
    height: 50%;
    position: relative;
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
}

.sk-folding-cube .sk-cube:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #3cf;
    -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;
    animation: sk-foldCubeAngle 2.4s infinite linear both;
    -webkit-transform-origin: 100% 100%;
    -ms-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
}

.sk-folding-cube .sk-cube2 {
    -webkit-transform: scale(1.1) rotateZ(90deg);
    transform: scale(1.1) rotateZ(90deg);
}

.sk-folding-cube .sk-cube3 {
    -webkit-transform: scale(1.1) rotateZ(180deg);
    transform: scale(1.1) rotateZ(180deg);
}

.sk-folding-cube .sk-cube4 {
    -webkit-transform: scale(1.1) rotateZ(270deg);
    transform: scale(1.1) rotateZ(270deg);
}

.sk-folding-cube .sk-cube2:before {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
}

.sk-folding-cube .sk-cube3:before {
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
}

.sk-folding-cube .sk-cube4:before {
    -webkit-animation-delay: 0.9s;
    animation-delay: 0.9s;
}

@-webkit-keyframes sk-foldCubeAngle {

    0%,
    10% {
        -webkit-transform: perspective(140px) rotateX(-180deg);
        transform: perspective(140px) rotateX(-180deg);
        opacity: 0;
    }

    25%,
    75% {
        -webkit-transform: perspective(140px) rotateX(0deg);
        transform: perspective(140px) rotateX(0deg);
        opacity: 1;
    }

    90%,
    100% {
        -webkit-transform: perspective(140px) rotateY(180deg);
        transform: perspective(140px) rotateY(180deg);
        opacity: 0;
    }
}

@keyframes sk-foldCubeAngle {

    0%,
    10% {
        -webkit-transform: perspective(140px) rotateX(-180deg);
        transform: perspective(140px) rotateX(-180deg);
        opacity: 0;
    }

    25%,
    75% {
        -webkit-transform: perspective(140px) rotateX(0deg);
        transform: perspective(140px) rotateX(0deg);
        opacity: 1;
    }

    90%,
    100% {
        -webkit-transform: perspective(140px) rotateY(180deg);
        transform: perspective(140px) rotateY(180deg);
        opacity: 0;
    }
}

</style>
<style lang="scss">
.mentor-profile-editor {
    .dz-message span {
        font-family: 'Open Sans', sans-serif;
        font-size: 1.6rem;
        color: #b0b0b0
    }
}

</style>



// WEBPACK FOOTER //
// MentorProfileEditor.vue?5307344a